
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sexleketoy/vibrator",
      function () {
        return require("private-next-pages/sexleketoy/vibrator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sexleketoy/vibrator"])
      });
    }
  